export function collectClientInfo() {
  // #ifdef H5
  const ua = navigator.userAgent;

  let deviceType = 'desktop';
  if (/Mobile|Android.*Mobile|Windows Phone|IEMobile|Opera Mini/i.test(ua)) {
    deviceType = 'mobile';
  }
  else if (/iPad|Tablet|Android(?!.*Mobile)|Silk/i.test(ua)) {
    deviceType = 'tablet';
  }

  let os = 'unknown';
  if (/Windows/i.test(ua)) os = 'Windows';
  else if (/Mac OS X|MacIntel|MacPPC/i.test(ua)) os = 'macOS';
  else if (/Android/i.test(ua)) os = 'Android';
  else if (/iOS|iPhone|iPad|iPod/i.test(ua)) os = 'iOS';
  else if (/Linux/i.test(ua)) os = 'Linux';

  let browser = 'unknown';
  if (/Edg\/|Edge\//i.test(ua)) browser = 'Edge';
  else if (/Chrome\/|CriOS\//i.test(ua)) browser = 'Chrome';
  else if (/Firefox\/|FxiOS\//i.test(ua)) browser = 'Firefox';
  else if (/Safari\//i.test(ua)) browser = 'Safari';
  else if (/Opera|OPR\//i.test(ua)) browser = 'Opera';
  else if (/Trident|MSIE/i.test(ua)) browser = 'IE';

  const screenResolution = `${window.screen.width}x${window.screen.height}`;

  return { userAgent: ua, deviceType, os, browser, screenResolution };
  // #endif

  // #ifndef H5
  const info = uni.getSystemInfoSync();
  return {
    userAgent: `${info.brand || ''}/${info.model || ''}`,
    deviceType: info.deviceType || 'mobile',
    os: info.osName || info.platform || 'unknown',
    browser: info.browserName || 'unknown',
    browserVersion: info.appVersion || '',
    screenResolution: `${info.screenWidth || 0}x${info.screenHeight || 0}`,
  };
  // #endif
}
